module.exports = __webpack_public_path__ + "img/detail_1.648afe36.png";